export default __webpack_public_path__ + "static/media/LOGO_contruyendo_header_bco.8d9d9165.png";